import { useState } from 'react';
import { Slide, Snackbar } from '@mui/material';
import { Alert } from '@mui/lab';

function TransitionDown(props) {
    return <Slide {...props} direction="down" />;
}

const SimpleAlert = ({ severity = 'success', message = '', onClose, autoHideDuration = 5000 }) => {
    const [open, setOpen] = useState(true);

    const handleClose = () => {
        setOpen(false);
        setTimeout(() => {
            onClose && onClose();
        }, 100);
    };

    return (
        <Snackbar
            autoHideDuration={autoHideDuration}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={open}
            onClose={handleClose}
            TransitionComponent={TransitionDown}
        >
            <Alert severity={severity} sx={{ width: '100%' }}>
                {message}
            </Alert>
        </Snackbar>
    );
};

export default SimpleAlert;
